export enum CALCULATOR_ELEMENT_PERIOD {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month'
}
